import {SxProps} from "@mui/material";

enum Typography {
    bodyP4 = "bodyP4"
}

export const typographySx: {
    [key in Typography]: SxProps
} = {
    bodyP4: {
        fontFamily: "Inter",
        fontSize: "14px",
        fontWeight: 400,
        lineHeight: "20px"
    }
}
